import { DateTime } from "luxon";

export const areDatesEqual = (timeframeDate: string | undefined, selectorDate: Date): boolean => {
  return (
    DateTime.fromISO(timeframeDate as string).toFormat("yyyy-MM-dd") ==
    DateTime.fromJSDate(selectorDate).toFormat("yyyy-MM-dd")
  );
};
